import React from 'react'
import ProjectEdit from "../../components/Project/Edit/ProjectEdit";
export default function ProjectDetails() {
  return (
    <div>
        <ProjectEdit/>
    </div>
  )
}
